// extracted by mini-css-extract-plugin
module.exports = {"container":"status-icon_container__1nRJ5","container_active":"status-icon_container_active__1wyWX","container_archived":"status-icon_container_archived__VLIv9"};